import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';

const AvailabilityLosses = () => import('./pages/AvailabilityLosses.vue');
const PerformanceLosses = () => import('./pages/PerformanceLosses.vue');
const QualityLosses = () => import('./pages/QualityLosses.vue');

const moduleRoutes = [
  {
    path: 'availability-losses',
    name: 'AvailabilityLosses',
    component: AvailabilityLosses,
    meta: {
      allowAnonymous: false,
      ability: {
        subject: USER_SUBJECTS.LOSSES,
        action: USER_ACTIONS.READ,
      },
      isNextAppPage: true,
    },
  },
  {
    path: 'quality-losses',
    name: 'QualityLosses',
    component: QualityLosses,
    meta: {
      allowAnonymous: false,
      ability: {
        subject: USER_SUBJECTS.LOSSES,
        action: USER_ACTIONS.READ,
      },
      isNextAppPage: true,
    },
  },
  {
    path: 'performance-losses',
    name: 'PerformanceLosses',
    component: PerformanceLosses,
    meta: {
      allowAnonymous: false,
      ability: {
        subject: USER_SUBJECTS.LOSSES,
        action: USER_ACTIONS.READ,
      },
      isNextAppPage: true,
    },
  },
];

export default (router) => {
  for (let route of moduleRoutes) {
    router.addRoute(ROUTE_NAMES.BASE_LAYOUT, route);
  }
};
